export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=67a94df2&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/lk/main/index.vue?vue&type=template&id=67a94df2&
// module id = 1062
// module chunks = 0